import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as BaseLink } from 'react-router-dom';

export const Wrapper = styled(Stack)``;

export const Link = styled(BaseLink)`
  text-decoration: none !important;
  color: inherit;
`;
